export const REDURECTION_URLS = {
    AUTISM: 'https://www.lifelabs.com/patients/patient-centred-care/serving-patients-with-autism/',
    PATIENT_TEST_INSTRUCTIONS: 'https://www.lifelabs.com/patients/preparing-for-a-test/patient-test-instructions/',
    MY_VISIT: ' https://myvisit.lifelabs.com/?utm_source=LocationFinder&utm_medium=Website&utm_campaign=MyVisit_LocationFinderLL',
    HOME_VISIT: 'https://myvisit.lifelabs.com/?utm_source=LocationFinder&utm_medium=Website&utm_campaign=MyVisit_LocationFinderLL',
    BC_FAQ: 'https://www.bc.mycarecompass.lifelabs.com/faq',
    FAQ: 'https://www.on.mycarecompass.lifelabs.com/faq',
    WHAT_TO_EXPECT: 'https://www.lifelabs.com/patients/what-to-expect/'
}